import React from 'react';
import {connect} from 'react-redux';
import {updateModalContent} from "./redux/FeedbackRedux";
import Modal from "./Modal";

const AISummaryRightBlock = ({ item, index, isIssues }) => {
    if (!item) {
        return null;
    }

    const potentialSolutionsKey = item['potential_solutions'] ? 'potential_solutions' : 'potential_insights';

    return (
        <div className="aisummary-summary-text-wrapper mt-3" data-id={index}>
            <h5 className="border-bottom">{ item.title }</h5>

            <h6>{ __('Summary') }</h6>
            <p>{ item.explanation }</p>

            <h6>{ isIssues ? __('Potential Solutions') : __('Potential Insights') }</h6>
            { item[potentialSolutionsKey].map((solution, index) => {
                return (
                    <p key={index}>{ solution }</p>
                )
            })}

            {/* Example Feedbacks */}
            {item['feedbacks'] && item['feedbacks'].length > 0 && <h6>{ __('Example Feedbacks') }</h6>}
            <ul>
                {item['feedbacks'] && item['feedbacks'].length > 0 && item['feedbacks']
                    .filter(feedback => feedback?.description)
                    .slice(0, 3)
                    .map((feedback, index) => (
                        <li key={index}>
                            <a href={feedback?.url} target="_blank">{feedback?.description}
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M10 5H8.2c-1.12 0-1.68 0-2.108.218a1.999 1.999 0 0 0-.874.874C5 6.52 5 7.08 5 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.105.218h7.606c1.118 0 1.677 0 2.104-.218.377-.192.683-.498.875-.874.218-.428.218-.987.218-2.105V14m1-5V4m0 0h-5m5 0-7 7"
                                        stroke="#373c40" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </a>
                        </li>
                ))}
            </ul>

            {/* Example Reviews */}
            {item['reviews'] && Object.keys(item['reviews']).length > 0 && <h6>{ __('Example Public Reviews') }</h6>}
            <ul>
                {item['reviews'] && Object.keys(item['reviews']).length > 0 &&
                    Object.values(item['reviews']) // Convert object of objects into an array
                        .filter(feedback => feedback?.description) // Filter out items without descriptions
                        .slice(0, 3) // Limit to 3 items
                        .map((feedback, index) => (
                            <li key={index}>
                                <a href={feedback.url} target="_blank" rel="noopener noreferrer">
                                    {feedback.description}
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M10 5H8.2c-1.12 0-1.68 0-2.108.218a1.999 1.999 0 0 0-.874.874C5 6.52 5 7.08 5 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.105.218h7.606c1.118 0 1.677 0 2.104-.218.377-.192.683-.498.875-.874.218-.428.218-.987.218-2.105V14m1-5V4m0 0h-5m5 0-7 7"
                                            stroke="#373c40" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </a>
                            </li>
                ))}
            </ul>
        </div>
    )
};

class AISummary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showIssues: this.props.issueStories && Object.keys(this.props.issueStories).length > 0,
            selectedIndex: 0,
        }

        this.selectRef = React.createRef();
        this.handleEmailClick = this.handleEmailClick.bind(this);
        this.sortItemsAsc = this.sortItemsAsc.bind(this);
    }

    // get the data based on the selected tab
    itemsData = () => {
        let itemData;

        if (this.state.showIssues) {
            itemData = this.props.issueStories?.issues;
        } else {
            itemData = this.props.successStories?.success_stories;
        }

        if (!itemData || typeof itemData !== "object") return []; // Ensure it's an object before processing

        //
        return this.sortItemsAsc(itemData);
    };

    sortItemsAsc = (items) => {
        return Object.entries(items)
            .sort(([, a], [, b]) => {
                const aFeedbacks = a.feedbacks ? Object.keys(a.feedbacks).length : 0;
                const aReviews = a.reviews ? Object.keys(a.reviews).length : 0;
                const bFeedbacks = b.feedbacks ? Object.keys(b.feedbacks).length : 0;
                const bReviews = b.reviews ? Object.keys(b.reviews).length : 0;

                const aTotal = aFeedbacks + aReviews;
                const bTotal = bFeedbacks + bReviews;

                if (bTotal !== aTotal) {
                    return bTotal - aTotal; // Sort by total sum (descending)
                }

                return bFeedbacks - aFeedbacks; // If sum is equal, sort by feedbacks (descending)
            })
            .map(([key, value]) => ({ id: key, ...value })); // Convert back to array format
    }

    // forward modal
    handleEmailClick(event) {
        event.preventDefault();
        const modal_id = "emailForwardModal";
        const modal_title = __("AI Summary Monthly Recipents");
        const modal_body = "renderEmailForwardSummary";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "cancel";
        const button_2_text = __("Close");

        this.props.dispatch(updateModalContent({
            modal_id: modal_id,
            modal_title: modal_title,
            modal_body: modal_body,
            button_1_class: button_1_class,
            button_1_id: button_1_id,
            button_1_text: button_1_text,
            button_2_class: button_2_class,
            button_2_id: button_2_id,
            button_2_text: button_2_text
        }));
        jQuery('.modal:not(.error)').modal();
    }

    render() {
        const items = this.itemsData();

        // construct the intro
        const businessName = this.props.business.name;
        const location = this.props.business.city;
        const startDate = this.props.reportStartDateFormatted;
        const endDate = this.props.reportEndDateFormatted;
        const feedbackCount = this.props.aiSummaryTotalFeedbacks;
        const reviewsCount = this.props.aiSummaryTotalReviews;

        const analysisText = __(
            `This analysis covers <strong>${feedbackCount} Feedbacks</strong> ${
                reviewsCount > 0 ? `and <strong>${reviewsCount} Public Reviews </strong>` : ''
            } received for <strong>${businessName} ${location}</strong> collected between <strong>${startDate}</strong> and <strong>${endDate}</strong>.`
        );

        // check if the URL has already a date set
        const currentPath = window.location.pathname;
        const urlMatch = currentPath.match(/\/(\d{4}-\d{2})$/);
        const currentValue = urlMatch ? urlMatch[1] : "";

        // construct the pdf URL
        const PDFmonth = currentValue.length > 0
            ? currentValue
            : Object.keys(this.props.availablePeriods)[0];

        const PDFurl = currentValue
            ? currentPath.replace(/\/\d{4}-\d{2}$/, `/${PDFmonth}`) + '/pdf'
            : `${currentPath}/${PDFmonth}/pdf`;

        return (
            <div className="w-100 right-side-content">
                <div className="main-section">
                    <div className="w-100 p-2 bg-white border-bottom shadow-sm d-flex align-items-center p-3">
                        <p className='mb-0 w-100'>{__('On this page you can access AI-generated summaries of all Feedback received during the selected month. Our in-depth analysis highlights trending issues, provides specific Feedback examples of customer comments, and offers tailored recommendations for improvement. You can explore historical summaries for any month, allowing you to track changes over time and gain valuable insights into customer satisfaction.')}.</p>
                    </div>

                    <div className="col-12 mt-3">
                        {/* Content */}
                        {this.props.isManager &&
                            <div className="card flex-row align-items-center pt-3 pb-3">
                                <h5 className="pl-3 pr-3 mb-0">{__('Monthly AI Summary Recipients')}:</h5>

                                <button
                                    onClick={this.handleEmailClick}
                                    className={'btn btn-primary ml-3'}
                                >
                                    {__('Manage Recipients')}
                                </button>
                            </div>
                        }

                        {/* Business Address */}
                        <div className="col-sm-12 mt-3 p-0">
                            <div id='report_body' className="card col-sm-12 p-0 mt-3">
                                <div className="title-row border-bottom">
                                    <div className="card-title tab">
                                        <h5 className="pl-3 pr-3">{__('AI Summary')}</h5>
                                    </div>
                                    <p className="aisummary-address mb-0 pl-3 pr-3 pb-0">
                                        {this.props.business['street_address']}, {this.props.business['city']}, {this.props.business['state']}, {this.props.business['zip_code']}
                                    </p>

                                </div>

                                {/* Report Summary */}
                                {(this.props.aiSummaryTotalFeedbacks > 0 || this.props.aiSummaryTotalReviews > 0) &&
                                    <p className="px-3 py-2 summary-intro-p" dangerouslySetInnerHTML={{ __html: analysisText }} />
                                }
                            </div>
                        </div>
                    </div>

                    {/* Analysis */}
                    <div className="w-100 justify-content-center">
                        <div className="col-sm-12 mt-3">
                            <div className="card col-sm-12 p-0 mt-3 <?= $isWeb ? 'web-view' : '' ?>">
                                {/* Top Bar */}
                                <div className="title-row my-3">
                                    <div className="aisummary-toggle card-title">
                                        <div className="aisummary-toggle-wrapper" data-issues={this.state.showIssues}>
                                            {(this.props.issueStories && Object.keys(this.props.issueStories).length > 0) &&
                                                <button onClick={() => {
                                                    this.setState({selectedIndex: 0});
                                                    this.setState({showIssues: true})
                                                }}>
                                                    <i className="fad fa-solid fa-thumbs-down text-danger mr-1"></i>
                                                    {__('Issues Analysis')}
                                                </button>
                                            }

                                            {(this.props.successStories && Object.keys(this.props.successStories).length > 0) &&
                                                <button onClick={() => {
                                                    this.setState({selectedIndex: 0});
                                                    this.setState({showIssues: false})
                                                }}>
                                                    <i className="fad fa-solid fa-thumbs-up text-success mr-1"></i>
                                                    {__('Success Stories Analysis')}
                                                </button>
                                            }
                                        </div>
                                    </div>

                                    <div className="aisummary-actions card-title mr-0 ml-auto">
                                        <select
                                            onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                const currentPath = window.location.pathname;

                                                const updatedPath = currentPath.replace(/\/\d{4}-\d{2}$/, `/${selectedValue}`);
                                                // Update the URL
                                                window.location.href = updatedPath.includes(selectedValue) ? updatedPath : `${currentPath}/${selectedValue}`;
                                            }}
                                            id="aisummary-archive"
                                            className="mr-3"
                                            defaultValue={currentValue ? currentValue : Object.keys(this.props.availablePeriods)[0]}
                                        >
                                            <option value="" disabled>{ __('Select a month') }</option>
                                            {Object.keys(this.props.availablePeriods).map((key) => {
                                                const value = this.props.availablePeriods[key];
                                                return (
                                                    <option key={key} value={key}>
                                                        {value}
                                                    </option>
                                                );
                                            })}
                                        </select>

                                        <a
                                            href={PDFurl}
                                            target="_blank"
                                            className='run-report btn btn-primary mr-2'
                                            id="download-pdf-alt"
                                        ><i
                                            className="fas fa-file-download mr-1"></i> {__('Download PDF')}</a>
                                    </div>
                                </div>

                                {/* Analysis Section */}
                                <div className="aisummary-summary m-3" data-issues={this.state.showIssues}>
                                    {this.props.successStories.length === 0 && this.props.issueStories.length === 0 && (
                                        <h5 className='aisummary-nodata'>{__('AI Report not yet available')}</h5>
                                    )}

                                    {this.props.successStories['summary']?.length > 0 &&
                                        <div className="aisummary-summary-success">
                                            <h5>{__('Success Story Analysis')}</h5>
                                            <p>{this.props.successStories['summary']}</p>
                                        </div>
                                    }

                                    {this.props.issueStories['summary']?.length > 0 &&
                                        <div className="aisummary-summary-issues">
                                            <h5>{__('Issues Analysis')}</h5>
                                            <p>{this.props.issueStories['summary']}</p>
                                        </div>
                                    }
                                </div>

                                {/* Content */}
                                {this.props.successStories.length !== 0 && this.props.issueStories.length !== 0 && (
                                    <div className="aisummary-content-wrapper" data-issues="true">
                                    <div className="aisummary-content aisummary-content-issues">
                                        {/* Analysis Content */}
                                        <ul className="aisummary-terms-list m-3">
                                            {items &&
                                                <li className="aisummary-terms-list-item aisummary-terms-list-header">
                                                    <span>{this.state.showIssues
                                                        ? this.props.issueStories['issues'].length > 0
                                                            ? __('Issues')
                                                            : ''
                                                        : this.props.successStories['success_stories']?.length > 0
                                                            ? __('Success Stories')
                                                            : ''
                                                    }</span>

                                                    <span>
                                                        {this.state.showIssues
                                                            ? this.props.issueStories['issues'].length > 0
                                                                ? __('Number of Mentions')
                                                                : ''
                                                            : this.props.successStories['success_stories']?.length > 0
                                                                ? __('Number of Mentions')
                                                                : ''
                                                        }
                                                        <small className="ml-2">{ __('(Feedbacks - Public Reviews)') }</small>
                                                        <i
                                                            className="far fa-question-circle text-muted ml-2"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-title="{{ __('Feedbacks are private comments sent through the :platform platform. Public Reviews are collected from online public review sites where customers have left reviews.', ['platform' => tenant()->settings->companyName]) }}"
                                                        ></i>
                                                    </span>

                                                </li>
                                            }

                                            {items && items.map((issue, index) => {
                                                return (
                                                    <li
                                                        className="aisummary-terms-list-item"
                                                        onClick={() => {
                                                            console.log(index);
                                                            this.setState({selectedIndex: index})

                                                        }}
                                                        data-active={this.state.selectedIndex === index}
                                                        key={index}
                                                    >
                                                        <span>{ issue['title'] }</span>
                                                        <span>{ issue['feedbacks'] ? issue['feedbacks'].length : '0' } - { issue.reviews ? Object.keys(issue.reviews).length : '0' }</span>
                                                    </li>
                                                )
                                            })}
                                        </ul>

                                        {/* Item Text */}
                                        {((Array.isArray(this.props.issueStories['issues']) && this.props.issueStories['issues'].length > 0) ||
                                                (Array.isArray(this.props.successStories['success_stories']) && this.props.successStories['success_stories'].length > 0)) &&
                                            <AISummaryRightBlock
                                                item={this.state.showIssues
                                                    ? this.props.issueStories['issues'] ? this.sortItemsAsc(this.props.issueStories['issues'])[this.state.selectedIndex] : null
                                                    : this.sortItemsAsc(this.props.successStories['success_stories'])[this.state.selectedIndex]}
                                                index={this.state.selectedIndex}
                                                isIssues={this.state.showIssues}
                                            />
                                        }

                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {this.props.state.modal !== null &&
                    <Modal
                        modal={this.props.state.modal}
                        existingRecipients={this.props.existingRecipients}
                        contacts={this.props.contacts}
                        employees={this.props.employees}
                    />
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        business: state.business,
        issueStories: state.issueStories,
        successStories: state.successStories,
        existingRecipients: state.existingRecipients,
        contacts: state.contacts,
        employees: state.employees,
        availablePeriods: state.availablePeriods,
        reportStartDate: state.reportStartDate,
        reportEndDate: state.reportEndDate,
        totalIssuesMentions: state.totalIssuesMentions,
        totalIssuesReviewMentions: state.totalIssuesReviewMentions,
        totalSuccessStoriesMentions: state.totalSuccessStoriesMentions,
        totalSuccessReviewStoriesMentions: state.totalSuccessReviewStoriesMentions,
        reportStartDateFormatted: state.reportStartDateFormatted,
        reportEndDateFormatted: state.reportEndDateFormatted,
        isManager: state.isManager,
        aiSummaryTotalFeedbacks: state.aiSummaryTotalFeedbacks,
        aiSummaryTotalReviews: state.aiSummaryTotalReviews,
    }
}

export default connect(mapStateToProps)(AISummary)
